<div class="sms-offer-modal-container" *transloco="let t">
  @if(smsOfferCoupon.coupon?.imageUrl){
    <div class="image-container">
      <img [src]="smsOfferCoupon.coupon?.imageUrl" alt="">
    </div>
  }
  <div class="coupon-info-container" [ngClass]="{'only-right-radius': smsOfferCoupon.coupon?.imageUrl}">
    <div class="close-button-wrapper">
      <button
        class="button-undecorated close-button"
        [attr.aria-label]="t('modals.sms_sub_promo_modal.close_btn')"
        (click)="closeModal()"
      >
        <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
      </button>
    </div>

    <div class="scrollable-content">
      @if(!smsOfferCoupon.coupon?.imageUrl){
        <img [src]="'assets/images/sms-modal-notifications.png' | deployUrl" [alt]="'Sms Notification Image'" class="sms-notif-image"/>
      }
  
      <div class="header-wrapper">
        <span class="subscribe-prompt">{{t('modals.sms_sub_promo_modal.title')}}</span>
        <span class="coupon-name">{{
          smsOfferCoupon.coupon?.displayName
        }}</span>
        @if(smsOfferCoupon.coupon?.description){
          <cwo-offer-details [details]="smsOfferCoupon.coupon!.description"></cwo-offer-details>
        }
      </div>
  
      <div class="main-content">
        <span class="sms-prompt">{{t('modals.sms_sub_promo_modal.purchase_info')}}</span>
        <form  [cwoAriaForm]="form"
              [formGroup]="form"
              class="sms-form"
              (ngSubmit)="subscribe()">
          @if(Object.keys(serverErrors).length > 0 && !(serverErrors['cellPhone'] || serverErrors['phone'])) {
            <div class="generic-errors">
                @for (key of Object.keys(serverErrors); track $index) {
                  @if(key !== 'cellPhone' && key !== 'phone'){
                    <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{serverErrors[key]}}.</span>
                  }
                }
            </div>
          }
          @if(!isAccountInstantiated()){
          <div class="input-wrapper">
            <cwo-input #nameField
              formControlName="name"
              [placeholder]="'Name'"
              [type]="'text'"
              [required]="true"
              [invalid]="showErrors && name.invalid"
            />
            <div class="errors-wrapper">
              @if(showErrors && name.invalid && name.hasError('required')){
              <ng-container
                [ngTemplateOutlet]="inputError"
                [ngTemplateOutletContext]="{ error: validationMessages.name.required }"
              ></ng-container>
              }
            </div>
          </div>
          <div class="input-wrapper">
            <cwo-input  #emailField
              formControlName="email"
              [placeholder]="'Email'"
              [type]="'text'"
              [required]="true"
              [invalid]="showErrors && email.invalid"
            />
            <div class="errors-wrapper">
              @if(showErrors ){
                @if(email.invalid && email.hasError('required')){
                  <ng-container
                    [ngTemplateOutlet]="inputError"
                    [ngTemplateOutletContext]="{ error: validationMessages.email.required }"
                  ></ng-container>
                }
                @if(email.invalid && email.hasError('email')){
                  <ng-container
                    [ngTemplateOutlet]="inputError"
                    [ngTemplateOutletContext]="{ error: validationMessages.email.email }"
                  ></ng-container>
                }
              }
            </div>
          </div>
  
          }
          <div class="input-wrapper">
            <cwo-mask-field-input  #phoneField formControlName="phone" [label]="'Mobile Phone'"
                [maskPattern]="maskFieldInputType.phone"
                [invalid]="(showErrors && phone.invalid)" />
            <div class="errors-wrapper">
                @if(showErrors){
                @if(phone.hasError('required')){
                <span class="input-error"><cwo-icon class="icon"
                        [name]="iconNameType.error"></cwo-icon>{{validationMessages.phone.required}}</span>
                }
                @if(phone.hasError('minlength') || phone.hasError('maxlength') ){
                  <span class="input-error"><cwo-icon class="icon"
                    [name]="iconNameType.error"></cwo-icon>{{validationMessages.phone.minlength}}</span>
                }
                @if(serverErrors.phone){
                  <span class="input-error"><cwo-icon class="icon"
                    [name]="iconNameType.error"></cwo-icon>{{serverErrors.phone}}</span>
                }
                }
            </div>
          </div>
          @if(isAccountInstantiated() && !account()?.phone) {
            <div class="input-wrapper">
            <cwo-input #passwordField formControlName="password" [type]="'password'" [placeholder]="'Current Password'"
                  [required]="true" [invalid]="showErrors && password.invalid" />
              <div class="errors-wrapper">
                  @if(showErrors && password.invalid){
                  @if(password.hasError('required')){
                  <span class="input-error"><cwo-icon class="icon"
                          [name]="iconNameType.error"></cwo-icon>{{validationMessages.password.required}}</span>
                  }
                  @if(password.hasError('minlength') || password.hasError('maxlength') ){
                  <span class="input-error"><cwo-icon class="icon"
                          [name]="iconNameType.error"></cwo-icon>{{validationMessages.password.min_max}}</span>
                  }
                  }
              </div>
            </div>
          }
          
          <div class="input-wrapper">
            <cwo-checkbox formControlName="emailSubscription" [contentPlacement]="'right'" name="saveAddressCheckbox" [labelName]="t('modals.sms_sub_promo_modal.receive_offers_email')">
            </cwo-checkbox>
          </div>
  
        <div
          class="footer-wrapper"
          [ngClass]="{ 'fotter-wrapper-logedin': isAccountInstantiated() }"
        >
       
          <cwo-sms-sign-up-information></cwo-sms-sign-up-information>
          <button cwoAsyncButton [subscription]="loadingSub ?? null" class="button-accent subscribe-button"  type="submit">{{t('modals.sms_sub_promo_modal.subscribe_btn')}}</button>
          <button class="button-undecorated no-thanks-button" type="button" (click)="noThanks()">{{t('modals.sms_sub_promo_modal.no_thanks_btn')}}</button>
        </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #inputError let-error="error">
  <span class="input-error"
    ><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon
    >{{ error }}</span
  >
</ng-template>